module.exports = __webpack_public_path__ + "static/media/flight404-3.c76a024b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/presentation/flight404-3.jpg
// module id = 327
// module chunks = 11